<template>
  <v-app id="login">
    <v-content>
      <div class="enerman">
        <!-- style="width: 50vw" -->
        <v-layout row justify-center>
          <v-flex xs6 md5>
            <v-layout class="login-box">
              <v-flex md5 class="bg-img">
                <v-tooltip>
                  <template slot="activator">
                    <a target="_blank">
                      <img
                        class="img"
                        src="./../assets/logo/enerman-etisol.svg"
                        alt="enerman logo"
                        width="150px"
                        height="150px"
                      />
                    </a>
                  </template>
                </v-tooltip>
              </v-flex>
              <v-flex md7>
                <div class="login-inner-form">
                  <div class="details">
                    <h3 class="login-heading">{{ $t(settingType) }} {{ $t('Password') }}</h3>
                    <v-text-field
                      :label="$t('New Password')"
                      :type="show ? 'text' : 'password'"
                      :rules="[
                        rules.required,
                        rules.min,
                        computedPasswordStrength.message
                      ]"
                      v-model="password"
                      :placeholder="$t('New Password')"
                    >
                    </v-text-field>
                    <v-text-field
                      :label="$t('Confirm Password')"
                      :type="show ? 'text' : 'password'"
                      :rules="[
                        rules.required,
                        rules.min,
                        computedPasswordStrength.message
                      ]"
                      v-model="confirmPassword"
                      :placeholder="$t('Confirm Password')"
                    >
                    </v-text-field>
                    <v-progress-linear
                      background-opacity="0"
                      :color="computedPasswordStrength.color"
                      :value="progressValue"
                    ></v-progress-linear>
                    <v-checkbox
                      v-model="show"
                      :label="$t('Show password')"
                    ></v-checkbox>
                    <v-btn
                      block
                      large
                      color="#0E3F6D"
                      class="btn-md btn-theme"
                      @click.prevent="validatePasswordHandler"
                      >{{ $t('Submit') }}
                    </v-btn>
                    <div class="checkbox clearfix forgot" v-if="isSkip">
                      <v-btn class="btn-secondary" flat color="primary"
                        @click.prevent="skipHandler">
                        {{ $t('Skip') }}
                      </v-btn>
                    </div>
                    <div class="checkbox clearfix forgot" v-if="isBack">
                      <v-btn class="btn-secondary" flat color="primary"
                        @click.prevent="backHandler">
                        {{ $t('Back') }}
                      </v-btn>
                    </div>
                    <div class="checkbox clearfix forgot">
                      <select v-model="selectedLanguage" @change="languageChangeHandler">
                        <option v-for="(item, index) in Languages" :key="index" :value="item.value">
                          {{ item.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex md2 class="display-none">
            <div class="information">
              <p class="info-title">{{ $t('Must have atleast 8 characeters') }}.</p>
              <hr
                :style="{ width: '80%', margin: 'auto', marginTop: '-9px' }"
              />
              <p class="info-sub-title">{{ $t('Its better to have') }}:</p>
              <ul class="info-list">
                <li>{{ $t('Upper & lower case letters') }}</li>
                <li>{{ $t('A symbol (#&$)') }}</li>
                <li>{{ $t('A numerical value (0-9)') }}</li>
                <li>{{ $t('The longer the password, the better') }}</li>
              </ul>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </v-content>
  </v-app>
</template>

<script>
function checkPasswordStrength(password) {
  let score = 0;
  if (!password) {
    return { score: 0, message: "No password provided" };
  }
  if (password.length < 8) {
    return { score: 0, message: "Password is too short" };
  }
  if (password.length >= 8) {
    score++;
  }
  if (password.match(/\d+/)) {
    score++;
  }
  if (password.match(/[a-z]/) && password.match(/[A-Z]/)) {
    score++;
  }
  if (password.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,)]/)) {
    score++;
  }

  switch (score) {
    case 0:
    case 1:
      return { score, color: "red", message: "Weak" };
    case 2:
      return { score, color: "orange", message: "Moderate" };
    case 3:
      return { score, color: "yellow", message: "Strong" };
    case 4:
      return { score, color: "light-green", message: "Very Strong" };
    default:
      return { score, color: "green", message: "Very Strong" };
  }
}

import i18n from '@/plugins/i18n';
import LoginService from "@/services/login";
import { mapMutations, mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  data: () => ({
    settingType: "",
    show: false,
    password: "",
    confirmPassword: "",
    buttonStatus: false,
    isSkip: false,
    user: "",
    email: "",
    rules: {
      required: (v) => !!v || "Password is required",
      min: (v) => v.length >= 8 || "Use 8 characters or more for your password"
    },
    Languages: [
      {
        text: 'English',
        value: 'en'
      },
      {
        text: 'French',
        value: 'fr'
      }
    ],
    selectedLanguage: 'en'
  }),
  mounted() {
    let infoBuffer = "";
    let infoJson = {};
    this.selectedLanguage = this.getGeneralState('language')
    i18n.locale = this.selectedLanguage
    if (this.$route.query.info) {
      infoBuffer = Buffer.from(this.$route.query.info, "base64").toString();
      infoJson = JSON.parse(infoBuffer);
      this.SET_PASSWORD_CHANGE_STATUS(infoJson.status);
    }

    if (this.getGeneralState("passwordChangeStatus") == "update") {
      // When landing to this page via login
      this.isSkip = this.getGeneralState("isPasswordUpdateSkip");
      // TODO: Still confused How its gonna work
      this.user = this.getGeneralState("userData")["userName"];
      this.email = this.getGeneralState("userData")["email"];
      this.settingType = "Update";
    } else if (this.getGeneralState("passwordChangeStatus") == "new") {
      // When landing to this page via update link
      this.user = infoJson.user;
      this.email = infoJson.email;
      this.settingType = "Set";
      if (infoJson.valid < moment().unix()) {
        this.SET_SHOW_SNACKBAR(true);
        this.SET_SNACKBAR_CONTENT({
          icon: "error",
          header: "Error",
          message: "This link has expired",
        });
        this.$router.push("/404");
      }
    } else if (this.getGeneralState("passwordChangeStatus") == "reset") {
      // When landing to this page via reset password link
      this.user = infoJson.user;
      this.email = infoJson.email;
      this.settingType = "Reset";
      if (infoJson.valid < moment().unix()) {
        this.SET_SHOW_SNACKBAR(true);
        this.SET_SNACKBAR_CONTENT({
          icon: "error",
          header: "Error",
          message: "This link has expired",
        });
        this.$router.push("/404");
      }
    }
    if (this.getGeneralState("passwordResetDiff") >= 90) {
      this.SET_PASSWORD_UPDATE_SKIP(false);
      this.isSkip = false;
    } else if (
      this.getGeneralState("passwordResetDiff") >= 85 &&
      this.getGeneralState("passwordResetDiff") < 90
    ) {
      this.isSkip = true;
    }
  },
  computed: {
    ...mapGetters(["getRules", "getGeneralState"]),
    computedPasswordStrength() {
      return checkPasswordStrength(this.password);
    },
    progressValue() {
      return this.computedPasswordStrength.score * 25;
    },
    isBack() {
      return this.getGeneralState("passwordChangeStatus") == "update"
    }
  },
  methods: {
    ...mapActions(["resetState"]),
    ...mapMutations([
      "SET_THEME",
      "SET_PROGRESS_BAR",
      "SET_SHOW_SNACKBAR",
      "SET_SNACKBAR_CONTENT",
      "SET_PASSWORD_UPDATE_SKIP",
      "SET_PASSWORD_CHANGE_STATUS",
      "SET_LANGUAGE"
    ]),
    async validatePasswordHandler() {
      if (this.password == "" || this.confirmPassword == "") {
        this.SET_SHOW_SNACKBAR(true);
        this.SET_SNACKBAR_CONTENT({
          icon: "error",
          header: "Error",
          message: "Please fill new password and confirm password!",
        });
        return;
      }
      if (this.password !== this.confirmPassword) {
        this.SET_SHOW_SNACKBAR(true);
        this.SET_SNACKBAR_CONTENT({
          icon: "error",
          header: "Error",
          message: "Password does not match",
        });
        return;
      }
      if (this.computedPasswordStrength.score == 4) {
        if (this.password === this.getGeneralState("currentPassword")) {
          this.SET_SHOW_SNACKBAR(true);
          this.SET_SNACKBAR_CONTENT({
            icon: "error",
            header: "Error",
            message:
              "Your password should not be same as your previous password",
          });
          return;
        }
        this.SET_PROGRESS_BAR(true);
        this.buttonStatus = true;
        // Get the user from where ever possible
        LoginService.updatePassword({
          status: this.getGeneralState("passwordChangeStatus"),
          user: this.user,
          email: this.email,
          password: this.password,
        })
          .then((response) => {
            this.SET_PROGRESS_BAR(false);
            if (response.status == 200) {
              this.SET_PASSWORD_UPDATE_SKIP(true);
              this.SET_SHOW_SNACKBAR(true);
              this.SET_SNACKBAR_CONTENT({
                icon: "success",
                header: "Success",
                message:
                  "Password Successfully Updated! Email is sent with password in it",
              });
              if (
                this.getGeneralState("passwordChangeStatus") == "update"
              ) {
                if (this.getGeneralState("theme") == "light") {
                  this.SET_THEME(false);
                } else {
                  this.SET_THEME(true);
                }
                let address = "";
                if (this.getGeneralState("showHomeDB")) {
                  address = this.getRules([
                    "rule",
                    "access_config",
                    "home",
                    "path",
                  ]);
                } else {
                  address = this.getRules([
                    "rule",
                    "access_config",
                    "plantOverview",
                    "path",
                  ]);
                }
                console.log(address, "PATH ADDRESS");
                this.$router.push({ path: address });
              } else {
                this.$session.destroy();
                this.resetState();
                this.$router.push({
                  name: "login",
                });
              }
            }
          })
          .catch((err) => {
            this.buttonStatus = false;
            this.SET_PROGRESS_BAR(false);
            this.SET_SHOW_SNACKBAR(true);
            this.SET_SNACKBAR_CONTENT({
              icon: "error",
              header: "Error",
              message: "Password Update Failed",
            });
          });
      } else {
        this.SET_SHOW_SNACKBAR(true);
        this.SET_SNACKBAR_CONTENT({
          icon: "error",
          header: "Error",
          message: "Your password is not strong. Please fulfill the criteria!",
        });
      }
    },
    skipHandler() {
      if (this.getGeneralState("theme") == "light") {
        this.SET_THEME(false);
      } else {
        this.SET_THEME(true);
      }
      this.SET_PASSWORD_UPDATE_SKIP(true);
      this.SET_SHOW_SNACKBAR(true);
      this.SET_SNACKBAR_CONTENT({
        icon: "warning",
        header: "warning",
        message: this.$t('You have 10 days to reset the password', { num: 90 - this.getGeneralState("passwordResetDiff") }),
      });
      if (this.getGeneralState("showHomeDB")) {
        this.$router.push(
          `${this.getRules(["rule", "access_config", "home", "path"])}`
        );
      } else {
        this.$router.push(
          `${this.getRules(["rule", "access_config", "plantOverview", "path"])}`
        );
      }
    },
    async backHandler() {
      try {
        const payload = {
          token: this.getGeneralState("token"),
        };
        await LoginService.logoutUser(payload);
        this.$session.destroy();
        this.resetState();
        this.$router.push({
          name: "login",
        });
      } catch (err) {
        this.SET_SHOW_SNACKBAR(true);
        this.SET_SNACKBAR_CONTENT({
          icon: "error",
          header: "Error",
          message: "Could not go back to login page, please try again",
        });
        console.log(err, "ERROR ERROR ERROR");
      }
    },
    languageChangeHandler(event) {
      i18n.locale = event.target.value
      this.SET_LANGUAGE(event.target.value)
    }
  },
};
</script>

<style scoped>
.login-heading {
  margin: 0 0 25px;
  font-family: "Montserrat", sans-serif;
  font-size: 22px;
  font-weight: 400;
  color: #0e3f6d;
}

.enerman {
  background-image: url("./../assets/login/solar.jpg");
  background-color: #cccccc;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  /* opacity: 0.65; */
  height: 100vh;
  text-align: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
}

.login-box {
  display: flex;
  flex-flow: row wrap;
  /* margin: 0 150px 0 200px; */
  max-width: 700px;
  border-radius: 10px;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
  background: #fff;
}

.details {
  padding: 30px 60px 30px 0;
}

.details p a {
  margin-left: 3px;
  color: #717171;
}

.details p {
  margin-bottom: 0;
  font-size: 14px;
}

.bg-img {
  position: relative;
  background-size: cover;
  background: #0f3f6f;
  width: 100%;
  bottom: 0;
  border-radius: 10px;
  padding: 80px 30px;
  margin: 30px 0;
  left: -60px;
}

.login-inner-form .btn-md {
  cursor: pointer;
  padding: 10px 50px 8px 50px;
  letter-spacing: 1px;
  font-size: 15px;
  font-weight: 400;
  height: 45px;
  border-radius: 3px;
  text-transform: uppercase;
}

.login-inner-form button:focus {
  outline: none;
  outline: 0 auto -webkit-focus-ring-color;
}

.login-inner-form .btn-theme.focus,
.btn-theme:focus {
  box-shadow: none;
}

.login-inner-form .btn-theme {
  background: #1b548c;
  border: none;
  color: #fff;
}

.login-inner-form .btn-theme:hover {
  background: #194c7d;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
}

.information {
  margin-top: 5vh;
  width: 18vw;
  /* height: 14rem; */
  background: #fff;
  padding: 18px;
  border-radius: 1rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.3),
    0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2);
}

.information::before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 42vh;
  right: 37.2%;
  border: 0.75rem solid transparent;
  border-top: none;
  border-bottom-color: #fff;
  -webkit-filter: drop-shadow(0 -0.0625rem 0.0625rem rgba(0, 0, 0, 0.1));
  filter: drop-shadow(0 -0.0625rem 0.0625rem rgba(0, 0, 0, 0.1));
  transform: rotate(-90deg);
}

.info-title {
  font-weight: 500;
  font-size: 16px;
  line-height: 15px;
}

.info-sub-title {
  text-align: left;
  width: 80%;
  color: #6b6b6b;
  margin: 10px auto;
  line-height: 15px;
}

.info-list {
  width: 80%;
  color: #6b6b6b;
  text-align: left;
  padding-left: 60px;
}

.btn-secondary {
  cursor: pointer;
  padding: 10px;
  font-size: 15px;
  font-weight: 400;
  height: 20px;
  border-radius: 3px;
  text-transform: uppercase;
}

/** MEDIA **/
@media (max-width: 1264px) {
  .login-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .bg-img {
    padding: 0;
    left: 0px;
    margin: -25px 25px;
    width: calc(100% - 50px);
  }

  .details {
    padding: 30px;
  }

  .display-none {
    display: none;
  }
}
</style>

<style scoped>
select {
  display: inline-block;
  font-size: 17px;
  font-weight: normal;
  border-radius: 4px;
  padding: 0px 12px;
  width: 160px;
  height: 30px;
  /* reset */
  margin: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;

  border: 1px solid var(--v-primary-darken1);
  background-image:
    linear-gradient(45deg, transparent 50%, black 50%),
    linear-gradient(135deg, black 50%, transparent 50%);
  background-position: 129px 13px, 134px 13px;
  background-size:
    5px 5px,
    5px 5px;
  background-repeat: no-repeat;
}

select:active {
  background-image:
    linear-gradient(45deg, black 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, black 50%);
  background-position: 134px 13px, 129px 13px;
  background-size:
    5px 5px,
    5px 5px;
  background-repeat: no-repeat;
  border-color: none;
  outline: 0;
}

</style>
